import styled from "styled-components";
import { setFontVariant } from "@similarweb/styles";
import { colorsPalettes } from "@similarweb/styles";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const PopupContainer = styled.div`
    position: relative;
`;

export const PopupElementWrapper = styled.div`
    .Popup-element-wrapper--dark-mode {
        animation: fade 0.5s;
        animation-delay: 1s;
        animation-duration: 0.6s;
        animation-fill-mode: forwards;
        opacity: 0;
        visibility: hidden;
        border-radius: 3px;
        &::after {
            margin-left: -11px;
        }
    }

    @keyframes fade {
        to {
            opacity: 1;
            visibility: visible;
        }
    }
`;

export const PopupWrapper = styled(FlexColumn)`
    justify-content: space-between;
    align-items: flex-start;
`;

export const ButtonsWrapper = styled(FlexRow)`
    justify-content: right;
    padding-top: 25px;
    width: 100%;

    .outlinedBtn {
        min-width: 106px;
        ${setFontVariant("button", colorsPalettes.bluegrey[100])};
        border-color: ${colorsPalettes.carbon[0]};

        > div {
            color: ${colorsPalettes.carbon[0]};
        }

        &:hover {
            > div {
                color: ${colorsPalettes.carbon[0]};
            }
        }
    }
`;

export const PopupTitle = styled.div`
    margin-bottom: 5px;
    ${setFontVariant("subtitle2", colorsPalettes.bluegrey[100])};
    line-height: 16px;
`;
export const PopupSubTitle = styled.div`
    ${setFontVariant("tooltip", colorsPalettes.bluegrey[100])};
`;
